import { render, staticRenderFns } from "./servico.fiscal.vue?vue&type=template&id=4d95cf5c&"
import script from "./servico.fiscal.vue?vue&type=script&lang=js&"
export * from "./servico.fiscal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports